import { f7 } from 'framework7-react';
import { useRepairPickUpReserveState } from './hook/state/useRepairPickUpReserveState';
import { useStorageItem } from './hook/useStorageItem';
import { RepairPickUpReserve } from './repairPickUpReserve/repairPickUpReserve';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { paths } from '@/config/paths';

export const RepairPickUpReservePage = () => {
  const { stored } = useStorageItem<{
    carName: string;
    affiliateID: number;
    plantID: number;
    customerID: number;
    inspectionID: number;
    bodyPaintID: number;
  }>({ key: 'repairPickUpReserve' });
  const { setStorageItem: setReserveDate } = useStorageItem<{
    affiliateID: number;
    customerID: number;
    inspectionID: number;
    bodyPaintID: number;
    carName: string;
    firstPreferred: Date;
    secondPreferred?: Date;
    thirdPreferred?: Date;
  }>({ key: 'repairPickUpConfirm' });

  const {
    disabled,
    firstPreferredDateTime,
    secondPreferredDateTime,
    thirdPreferredDateTime,
    firstPreferredDate,
    secondPreferredDate,
    thirdPreferredDate,
    firstPreferredTime,
    secondPreferredTime,
    thirdPreferredTime,
  } = useRepairPickUpReserveState({
    plantID: stored?.plantID ?? 0,
    inspectionID: stored?.inspectionID ?? 0,
  });

  const handleClickBack = () => {
    f7.views.main.router.navigate(paths.bpsRepairInfoDetail);
  };

  const handleClickNext = () => {
    setReserveDate({
      carName: stored?.carName ?? '',
      affiliateID: stored?.affiliateID ?? 0,
      customerID: stored?.customerID ?? 0,
      bodyPaintID: stored?.bodyPaintID ?? 0,
      inspectionID: stored?.inspectionID ?? 0,
      firstPreferred: firstPreferredDateTime,
      secondPreferred: secondPreferredDateTime,
      thirdPreferred: thirdPreferredDateTime,
    });
    f7.views.main.router.navigate(paths.bpsRepairPickUpConfirm);
  };

  return (
    <PageTemplateComponent
      pageName={'pickUpReserve'}
      title={'依頼確認'}
      onBack={handleClickBack}
    >
      <RepairPickUpReserve
        onNext={handleClickNext}
        disabled={disabled}
        firstPreferredDate={firstPreferredDate}
        secondPreferredDate={secondPreferredDate}
        thirdPreferredDate={thirdPreferredDate}
        firstPreferredTime={firstPreferredTime}
        secondPreferredTime={secondPreferredTime}
        thirdPreferredTime={thirdPreferredTime}
      />
    </PageTemplateComponent>
  );
};
